import { FC } from 'react'

type Props = {
  isOpen: boolean
  defaultLabelList: string[]
  onClose: () => void
  onSelect: (label: string) => void
  className?: string
}

const DefaultLabelPopup: FC<Props> = (props) => {
  const { isOpen, defaultLabelList, onSelect, className } = props

  if (!isOpen) return null

  return (
    <div className={`defaultLabelPopup ${className ?? ''}`}>
      <div className="stack">
        {defaultLabelList.length === 0 ? (
          <p className="m-0">ラベルがありません。</p>
        ) : (
          defaultLabelList.map((label) => (
            <button
              key={label}
              type="button"
              className="btn btn-light text-start"
              onClick={() => onSelect(label)}
            >
              {label}
            </button>
          ))
        )}
      </div>
    </div>
  )
}

export default DefaultLabelPopup
